import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const QuestXPBar = ({ currentXP, nextLevelXP, level }) => {
  const { t } = useTranslation();
  const progress = nextLevelXP > 0 ? (currentXP / nextLevelXP) * 100 : 0;
  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className="w-full bg-gray-800 rounded-full h-6 relative overflow-hidden shadow-inner mb-6">
      <div 
        className="h-full rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 transition-all duration-500 ease-out shadow-lg"
        style={{ width: `${clampedProgress}%` }}
      >
        {/* Subtle aura effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse-slow opacity-50"></div>
      </div>
      <div className="absolute inset-0 flex items-center justify-between px-3 text-sm font-bold text-white">
        <span className="flex items-center">
          <LucideIcons.Sparkles size={16} className="mr-1 text-purple-300" />
          {t('questXPBar.level')} {level}
        </span>
        <span>{currentXP} / {nextLevelXP} {t('questXPBar.xp')}</span>
      </div>
    </div>
  );
};

export default QuestXPBar;
